const validators = {   
  price:{
    numericality: {
      greaterThan: 0,
      message: "^errors.expenses.add_price"
    }
  },
  reason:{
    length: {
      minimum: 1,
      message: "^errors.expenses.add_expense"
    }
  }    
};
  
export default validators;
  